export function getStoredUser() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    return parsed?.accessToken ? parsed : null;
  } catch (_) {
    return null;
  }
}

export function getAccessToken() {
  return getStoredUser()?.accessToken || '';
}

export function getAuthHeaders(headers = {}) {
  const accessToken = getAccessToken();
  if (!accessToken) {
    return { ...headers };
  }

  return {
    ...headers,
    Authorization: `Bearer ${accessToken}`,
  };
}

export async function fetchWithAuth(input, init = {}) {
  return fetch(input, {
    ...init,
    headers: getAuthHeaders(init.headers || {}),
  });
}
